@if (currentUser) {
  <div class="app-body">
    <div class="menu">
      <app-menu></app-menu>
    </div>
    <div class="content" style="display:inline; position: relative; top: 3.2em;">
      <div class="card" style="height: 95%;">
        <div class="card-body">
          <router-outlet style="height: 100%;"></router-outlet>
          @if (showReconnectingAlert) {
            <div class="alert-overlay">
              <div class="alert-box">
                <div class="alert-icon">
                  <div class="spinner-border text-warning" role="status"></div>
                </div>
                <div class="alert-content">
                  <h5>Connection Lost</h5>
                  <p>Trying to reconnect for fetching updates...</p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (!currentUser) {
  <div>
    <router-outlet></router-outlet>
  </div>
}